import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.8_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-d_655531feb6f0bac0c439dd38a5e5664d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutUsClient"] */ "/vercel/path0/src/app/(frontend)/components/AboutUs/AboutUsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalImageStack"] */ "/vercel/path0/src/app/(frontend)/components/ClientPortal/PortalImageStack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTAButtons"] */ "/vercel/path0/src/app/(frontend)/components/CTA/CTAButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedCards"] */ "/vercel/path0/src/app/(frontend)/components/EligibilityAssessment/AnimatedCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EligibilityAssessmentCTALink"] */ "/vercel/path0/src/app/(frontend)/components/EligibilityAssessment/CTALink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroContent","HeroScrollIndicator"] */ "/vercel/path0/src/app/(frontend)/components/Hero/HeroContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(frontend)/components/HomePageAnimations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/components/PersonaCards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RefreshRouteOnSave"] */ "/vercel/path0/src/app/(frontend)/components/RefreshRouteOnSave/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceListCarousel"] */ "/vercel/path0/src/app/(frontend)/components/ResourceList/ResourceListCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsClient"] */ "/vercel/path0/src/app/(frontend)/components/Stats/StatsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsClient"] */ "/vercel/path0/src/app/(frontend)/components/Testimonials/TestimonialsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisaTypesCarousel"] */ "/vercel/path0/src/app/(frontend)/components/VisaTypes/VisaTypesCarousel.tsx");
